import moment from "moment"
import { useEffect, useState } from "react"
import { Card, Col, Dropdown, Form, Jumbotron, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import ReactPaginate from "react-paginate"
import Get from "../../api/Get"
import { CONTROL_NOTIFICATION } from "../../api/Routes"
import ComponentModalErrorSever from "../ComponentModalErrorSever"
import SimpleTable from "../SimpleTable"

function ReporteControlNotificacion({t, auth}){
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(20)
    const [order, setOrder] = useState('id')
    const [pageCount, setPageCount] = useState(0)
    const [notificationType, setNotificationType] = useState("SMS")

    //error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        let mounted = true
        setLoading(true)
        let url = `${CONTROL_NOTIFICATION}/${page}/${count}/${order}?notificationType=${notificationType}`
        Get({url: url, access_token: auth.data.access_token})
        .then(response=>{
            //console.log(response)
            if(mounted){
                setItems(response.data.data.response.content)
                setPageCount(response.data.data.response.totalPages)
            }
            setLoading(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setItems([])
            setLoading(false)
        })
        return () => mounted = false;             
    }, [page, notificationType, count])

    const fillDate = cell => {
        return moment(cell, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")
      }

    const columns = [
        {
          dataField: "id",
          text: "ID",
          hidden: true,
        },
        {
            dataField: 'created_at',
            text: 'Creado',
            headerStyle: { width: '10%' },
            editable: false,
            formatter:fillDate
        },
        {
            dataField: 'destinyUser',
            text: 'Destino',
            headerStyle: { width: '20%' },
            editable: false  
        },
        {
            dataField: 'estatusDeliver',
            text: 'Estado de entrega',
            headerStyle: { width: '25%' },
            editable: false
        },
        {
            dataField: 'messageDeliver',
            text: 'Observación',
            headerStyle: { width: '25%' },
            editable: false
        }
    ];
    const handlePageClick = (data) =>{
        setPage(data.selected)
    }

    return (
        <>
            <Card className="shadow-1">
                <Card.Body>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="mr-5"><h6>Control de notificaciones</h6></div>
                        <div>
                            <Form.Control 
                                size="sm"
                                as="select"
                                className="form-control-sm"
                                value={notificationType}
                                onChange={e=>setNotificationType(e.target.value)}
                            >
                                <option value="SMS">SMS</option>
                                <option value="EMAIL">EMAIL</option>
                            </Form.Control>
                        </div>
                    </div>
                
                <Dropdown.Divider />
                    {
                        loading && 
                        <Col xs="12" md="12">
                            <div className="text-center my-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </Col>
                    }
                    {
                        (items.length === 0 && !loading) &&
                        <Col xs="12" md="12">
                            <Jumbotron>
                                <div className="text-center">
                                    <p className="m-0">No existe información a mostrar</p>
                                </div>
                            </Jumbotron>
                        </Col>                                    
                    }
                    {
                        (items.length > 0 && !loading) &&     
                        <Col xs="12" md="12">
                            <SimpleTable columns={columns} items={items} className="th-text-uppercase"/>
                        </Col>
                    }  
                    <Row className="mt-4 align-items-center">
                        <Col xs="12" md="10">
                            <ReactPaginate
                                previousLabel={<RiArrowLeftSLine />}
                                nextLabel={<RiArrowRightSLine />}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                            />
                        </Col>
                        <Col className="d-none d-md-block" xs="12" md="2">
                            <select className="select-pagin" onChange={e=>setCount(e.target.value)}>
                                <option value="20">20 / {t('pagina')}</option>
                                <option value="30">30 / {t('pagina')}</option>
                                <option value="50">50 / {t('pagina')}</option>
                            </select>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
        
    )
}

export default withTranslation()(ReporteControlNotificacion)